<div *ngIf="showHeader" class="content-heading page-list-heading">
  <div class="font-weight-bold w-100 title">{{ title }}</div>
  <div class="page-list-header-actions">
    <ng-content select="[header-actions]"></ng-content>
  </div>
</div>
<div>
  <ng-content select="[filters]" class="card"></ng-content>
  <div class="card layout-table-section">
    <ng-content select="[table-content]"></ng-content>
  </div>
</div>